import { useEffect, useRef, useState } from "react";
import { useLocation } from "react-router-dom";

function RouteTransition() {
  const location = useLocation();
  const initialRender = useRef(true);
  const [isTransitioning, setIsTransitioning] = useState(false);

  useEffect(() => {
    if (initialRender.current) {
      initialRender.current = false;
      return undefined;
    }

    setIsTransitioning(true);
    const timer = window.setTimeout(() => {
      setIsTransitioning(false);
    }, 720);

    return () => window.clearTimeout(timer);
  }, [location.pathname, location.search]);

  return (
    <div
      className={`route-transition ${isTransitioning ? "is-active" : ""}`}
      aria-hidden={!isTransitioning}
      aria-live="polite"
    >
      <div className="route-transition-progress" />
      <div className="route-transition-brand">
        <span className="route-transition-logo-halo" aria-hidden="true" />
        <img
          className="route-transition-logo"
          src={process.env.PUBLIC_URL + "/images/img/logo-loading.webp"}
          alt="Nova Vision"
        />
      </div>
    </div>
  );
}

export default RouteTransition;
